$.fn.isInViewport = function() {
    $this = $(this);
    var elementTop = $this.offset().top;
    var elementBottom = elementTop + $this.outerHeight() / 1.5;
    var viewportTop = $(window).scrollTop();
    var viewportHalf = viewportTop + $(window).height() / 1.5;
    return elementBottom > viewportTop && elementTop < viewportHalf;
};

$(window).on('load resize scroll', function() {

    // adds 'in view' class when element scrolls into viewport
    if ($(window).width() > 1200) {
        $('.js-in-view').each(function() {
            $this = $(this);

            if ($this.isInViewport()) {
                $this.addClass("in-view");

            } else {
                $this.removeClass("in-view");
            }
        });
    }

});